import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollProcessingGroupBy extends Layout {
    buttonAcceptUnaccept: Button;
    buttonEllipsis: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAcceptedCount: Label;
    labelTitle: Label;
    panelAccept: Panel;
    panelGroupByHeader: Panel;
    sourceOrderPayablesCache: DataSource;
    tableGroupBy: Table;
}
